import { type FocusCellEvent } from '../events/types.ts';
import { type SelectionState } from '../state/types.ts';
import { isSameCell } from '../utils/is-same-cell.ts';

import { type ReducerResponse } from './types.ts';

/**
 * Moves keyboard focus without replacing selection ranges. Dispatching the
 * already-focused position is an intentional noop.
 */
export function focusCellReducer(
  state: SelectionState,
  event: FocusCellEvent
): ReducerResponse {
  if (state.focusedCell && isSameCell(state.focusedCell, event.cell)) {
    return { next: state, delta: { kind: 'noop' } };
  }

  return {
    next: {
      ...state,
      focusedCell: event.cell,
      lastInteractionSource: event.source
    },
    delta: {
      kind: 'focusChanged',
      source: event.source,
      prev: state.focusedCell,
      next: event.cell
    }
  };
}
